/** Subtitle for “how many are active” cards (e.g. brand users, brand features). */
export function activeCountLabel(
  count: number,
  singular: string,
  plural: string,
): string {
  if (count === 0) return `No active ${singular}`;
  if (count === 1) {
    const titled = singular.charAt(0).toUpperCase() + singular.slice(1);
    return `1 Active ${titled}`;
  }
  return `${count} Active ${plural}`;
}
